module.exports = __webpack_public_path__ + "media/images/weather/411_night-f18cb9340505232c34a902cf99ab91c4.png";